import { isValidSchema } from "./util";
function createTimestampFromDateAndTime(date, time) {
    return new Date(new Date(`${date}T${time}`).toISOString());
}
export class Campaign {
    constructor(id, project, description, timestamp) {
        this.id = id;
        this.project = project;
        this.description = description;
        this.timestamp = timestamp;
    }
    static create(payload) {
        return new Campaign(payload.id, payload.project, payload.description, createTimestampFromDateAndTime(payload.date, payload.time));
    }
    // FIXME: This needs to be replaced with something better. An existing validator tool e.g. io-ts.
    static isValid(payload) {
        const schema = ["id", "project", "description", "date", "time"];
        return isValidSchema(payload, schema);
    }
}
//# sourceMappingURL=campaign.js.map